import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

// import {defineMessages} from 'react-intl';
import {LocalizedDocumentMeta} from 'shared/LocalizedDocumentMeta.jsx';

import Menu from '../menu/preMatch/Menu.jsx';
import Sports from '../menu/preMatch/Sports.jsx';
import Sport from '../menu/preMatch/Sport.jsx';
import League from '../menu/preMatch/League.jsx';

import Pagination from '../Pagination.jsx';

import Grid from '../grid-control';
import BetPanel from '../bet-panel-control';

import {
    requestLineHeaders as requestLineHeadersAction,
    requestSportLineHeaders as requestSportLineHeadersAction,
    requestLeagueLineHeaders as requestLeagueLineHeadersAction,
    clearLine as clearLineAction
} from 'actions/creators/Line';

import {initPreMatchMenu as initPreMatchMenuAction} from 'actions/creators/PreMatchMenu';

import {
    toggleSportPrematch as toggleSportPrematchAction,
    toggleLeaguePrematch as toggleLeaguePrematchAction,
    showAllPrematch as showAllPrematchAction
} from 'actions/creators/UserSelection';
import { getMetadata } from '../../../shared/metadata/metadata'

function loadData(props) {
    const {routeParams: {sportId, leagueId}, languageId} = props;

    if (!sportId && !leagueId) {
        props.requestLineHeadersAction({languageId});
    } else if (sportId && !leagueId) {
        props.requestSportLineHeadersAction({sportId, languageId});
    } else if (sportId && leagueId) {
        props.requestLeagueLineHeadersAction({leagueId, languageId});
    }
}

function filterMatches(matches, date, filter) {
    if (filter === null || filter === undefined) {
        return matches;
    }

    return matches.filter(m => m.get('startDate') <= date);
}

class SportsPage extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        routeParams: React.PropTypes.object,
        gridSelection: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        initPreMatchMenuAction: React.PropTypes.func.isRequired,
        requestLineHeadersAction: React.PropTypes.func.isRequired,
        requestSportLineHeadersAction: React.PropTypes.func.isRequired,
        requestLeagueLineHeadersAction: React.PropTypes.func.isRequired,
        clearLineAction: React.PropTypes.func.isRequired,
        toggleSportPrematchAction: React.PropTypes.func.isRequired,
        toggleLeaguePrematchAction: React.PropTypes.func.isRequired,
        showAllPrematchAction: React.PropTypes.func.isRequired,
        push: React.PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this._menuShowAll = this._menuShowAll.bind(this);
        this._sportClick = this._sportClick.bind(this);
        this._leagueClick = this._leagueClick.bind(this);
        this.changePage = this.changePage.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.state = {currentPage: 1, perPage: 50, filter: null};
    }

    componentWillMount() {
        const {
            initPreMatchMenuAction, showAllPrematchAction, toggleSportPrematchAction, toggleLeaguePrematchAction,
            languageId, routeParams
        } = this.props;

        const {sportId, leagueId} = routeParams;

        if (!sportId && !leagueId) {
            showAllPrematchAction();
        } else if (sportId && !leagueId) {
            toggleSportPrematchAction({id: sportId, showMatches: true});
        } else if (sportId && leagueId) {
            toggleLeaguePrematchAction({id: leagueId, sportId: sportId, showMatches: true});
        }

        initPreMatchMenuAction({languageId});
        loadData({...this.props});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routeParams !== this.props.routeParams || nextProps.languageId !== this.props.languageId) {

            if (!nextProps.routeParams.sportId && !nextProps.routeParams.leagueId) {
                this.props.showAllPrematchAction();
            } else if (nextProps.routeParams.sportId && !nextProps.routeParams.leagueId) {
                this.props.toggleSportPrematchAction({id: nextProps.routeParams.sportId, showMatches: true});
            } else if (nextProps.routeParams.sportId && nextProps.routeParams.leagueId) {
                this.props.toggleLeaguePrematchAction(
                    {
                        id: nextProps.routeParams.leagueId,
                        sportId: nextProps.routeParams.sportId,
                        showMatches: true
                    });
            }

            loadData({...nextProps});

            const state = this.state;
            this.setState({...state, currentPage: 1, paginationItemCount: nextProps.matches.size});
        }

        if (nextProps.languageId !== this.props.languageId) {
            this.props.initPreMatchMenuAction({languageId: nextProps.languageId});
        }
    }

    calculateMatchCount() {
        let matchCounter = 0;
        let $this = this;

        let dateFilter;

        let {filter} = this.state;

        if (filter === null) {
            dateFilter = null;
        } else {
            const date = new Date();

            dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
        }

        this.props.leagues.map(function (league) {
            let leagueMatches = $this.props.matches.filter(match => match.get('leagueId') === league.get('id'));
            let filteredMatches = [];
            if (leagueMatches.size > 0) {
                filteredMatches = filterMatches(leagueMatches, dateFilter, $this.state.filter);
            }
            matchCounter += filteredMatches.size;
        });

        return matchCounter;
    }

    componentWillUnmount() {
        this.props.clearLineAction();
    }

    _menuShowAll() {
        this.props.push(`/sports`);
    }

    _sportClick(id) {
        this.props.push(`/sports/${id}`);
    }

    _leagueClick(sportId, id) {
        this.props.push(`/sports/${sportId}/${id}`);
    }

    changePage(currentPage) {
        const state = this.state;
        this.setState({...state, currentPage});
    }

    changeFilter(filter) {
        const state = this.state;
        this.setState({...state, filter, currentPage: 1});
    }

    render() {
        const {
            toggleSportPrematchAction,
            toggleLeaguePrematchAction,
            gridSelection,
            gridLocalization,
            routeParams,
            isShortcut,
            countryCode,
        } = this.props;

        const menu = {
            params: routeParams,
            showSlider: true,
            showBookmarks: false,
            showCalendar: true,
            showMatches: false,
            sportsElement: Sports,
            sportElement: Sport,
            leagueElement: League,
            showAllSports: true,
            gridSelection: gridSelection,
            showAllCallback: this._menuShowAll,
            sportClickCallback: this._sportClick,
            leagueClickCallback: this._leagueClick,
            selectionToggleCallback: toggleSportPrematchAction,
            selectionToggleLeagueCallback: toggleLeaguePrematchAction,
            isShortcut
        };

        const sportProps = {
            section: "preMatch",
            matchId: routeParams.matchId,
            sportId: routeParams.sportId,
            currentPage: this.state.currentPage,
            perPage: this.state.perPage,
            gridLocalization,
            changeFilter: this.changeFilter
        };

        const metadata = getMetadata(countryCode, routeParams.sportId);

        return (
            <div className="no-scroll-wrapper">
                <LocalizedDocumentMeta title={metadata.title} description={metadata.description} keywords={metadata.keywords}/>
                <div id="left" className='sports-left'>
                    <Menu {...menu}/>
                </div>
                <div id="right">
                    <BetPanel/>
                </div>
                <div id="center" className='sports-center'>
                    <Grid {...sportProps} />
                    {
                        !this.props.routeParams.leagueId &&
                        <Pagination
                            count={this.calculateMatchCount()}
                            perPage={this.state.perPage}
                            currentPage={this.state.currentPage}
                            changePage={this.changePage}
                        />
                    }
                </div>
            </div>
        );
    }
}

function select(state, props) {
    const languageId = state.application.get('languageId');
    const gridSelection = state.application.getIn(['userGridSelection', 'preMatch']);
    const matches = state.application.getIn(['preMatch', 'matches']);
    const leagues = state.application.getIn(['preMatch', 'leagues']);
    const countryCode = state.application.get('countryCode');

    return {
        languageId,
        gridSelection,
        matches,
        leagues,
        countryCode
    };
}

export default connect(select, {
    initPreMatchMenuAction,
    requestLineHeadersAction,
    requestSportLineHeadersAction,
    requestLeagueLineHeadersAction,
    clearLineAction,
    toggleSportPrematchAction,
    toggleLeaguePrematchAction,
    showAllPrematchAction,
    push
})(SportsPage);



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/SportsPage.jsx